'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _is = require('is');

var _is2 = _interopRequireDefault(_is);

var cfg = {
    domain: 'django',
    activeLanguage: null,
    languageCode: null,
    logger: console,
    localeData: {},
    onLanguageChange: function onLanguageChange() {
        if (typeof window !== 'undefined') {
            window.location.reload();
        }
    }
};

var setConfig = function setConfig(key, val) {
    cfg[key] = val;
};

exports.setConfig = setConfig;
var getConfig = function getConfig(key) {
    var res = cfg[key];

    if (key === 'activeLanguage' || key === 'languageCode') {
        if (_is2['default'].fn(res)) {
            res = res();
        }
    }

    return res;
};

exports.getConfig = getConfig;
var getLogger = function getLogger() {
    return cfg.logger;
};

exports.getLogger = getLogger;
var onLanguageChange = function onLanguageChange(newLanguage) {
    return cfg.onLanguageChange(newLanguage);
};
exports.onLanguageChange = onLanguageChange;


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-i18n/dist/config.js
 ** module id = 503
 ** module chunks = 1
 **/